export default {
    'help.page_title': 'Help',
    'help.search_placeholder': 'Type a task — for example, "create invoice"',
    'help.no_results': 'No matching guides. Try a shorter search.',
    'help.domain_article_count': '{count} guide | {count} guides',
    'help.back_to_home': 'Back to Help',
    'help.article_loading': 'Loading…',
    'help.return_to_home': 'Return to Help Section',
    'help.maximize': 'Maximise',
    'help.restore': 'Restore',

    'help.domains.accounting': 'Accounting',
    'help.domains.accounts-payable': 'Accounts Payable',
    'help.domains.accounts-receivable': 'Accounts Receivable',
    'help.domains.banking': 'Banking',
    'help.domains.crm': 'CRM',
    'help.domains.finance': 'Finance',
    'help.domains.human-resource': 'Human Resource',
    'help.domains.inventory': 'Inventory',
    'help.domains.investment': 'Investment',
    'help.domains.project': 'Projects',
    'help.domains.reports': 'Reports',
    'help.domains.tax-compliance': 'Tax Compliance',
};
